@if(isVisible() && !isShortcutsHidden()) {
  <div #mainAnchor class="w-fit max-h-[900px] flex flex-col gap-2">
    @for (option of listOptions; track option.id; let i = $index) {
      @if (enabledOptions.includes(option.id)) {
        @if (option.tabs?.()?.length) {
          <div
             #directiveRef="tooltipStaticDirective"
            (click)="directiveRef?.showTooltip()"
            [libTooltipStatic]="tooltipContent"
            [yAxis]="'end'"
            [xAxis]="'end'" 
            class="relative cursor-pointer">
              <div class="w-2 h-2 rounded-full bg-success absolute top-[12px] right-[12px]"></div>
              <div #tooltipContent class="w-[200px] bg-background border-radius-6 border-1 border-border-solid p-[16px] pt-[12px] flex flex-col gap-[8px]">
                <div class="flex items-center justify-between pb-[8px]">
                  <h4 class="content-semibold leading-[24px] text-foreground">{{option.description | translate}}</h4>
                  <i class="text-[16px] leading-[16px] h-[16px] fi fi-rr-cross-small text-muted-foreground hover:text-foreground cursor-pointer" (click)="directiveRef?.hideTooltip(true)"></i>
                </div>
                @for (tab of option.tabs(); track tab.id) {
                  <button class="group bg-muted-solid hover:opacity-80 px-[8px] py-[6px] border-radius-4 flex items-center gap-[8px]" (click)="shortcutsStore.setEditUnsavedDataId(tab.id); tab.action?.(); directiveRef?.hideTooltip(true);">
                    <div class="w-[16px] h-[16px] flex items-center justify-center">
                      <div class="w-[6px] h-[6px] rounded-full bg-foreground"></div>
                    </div>
                    <span class="text-foreground content-sm-semibold leading-[20px]">{{tab.name | translate}}</span>
                    <i class="hidden group-hover:block ml-auto text-[16px] leading-[16px] h-[16px] fi fi-rr-cross-small text-muted-foreground hover:text-foreground cursor-pointer" (click)="$event.stopPropagation(); removeFromUnsavedData(tab.id)"></i>
                  </button>
                }
                <button (click)="onIconButtonClick(option); directiveRef?.hideTooltip(true);" class="bg-muted-solid hover:opacity-80 px-[8px] py-[6px] border-radius-4 flex items-center gap-[8px]">
                    <i class="text-[16px] leading-[16px] h-[16px] fi fi-rr-plus-small text-foreground"></i>
                    <span class="text-foreground content-sm-semibold leading-[20px]">{{'COMPONENTS.SHORTCUTS.OPEN_NEW' | translate}}</span>
                </button>
              </div>
              <lib-icon-button [screen]="'mobile'" [icon]="iconMap[option.identifier] || 'question'" [style]="'rounded'" [type]="'ghost'"></lib-icon-button>
          </div>
      } @else {
      <div
      (click)="onIconButtonClick(option)"
      lib-tooltip
      [tooltipContent]="option.description"
      [yAxis]="'end'"
      [xAxis]="'end'"
       class="relative cursor-pointer">
        <lib-icon-button [screen]="'mobile'" [icon]="iconMap[option.identifier] || 'question'" [style]="'rounded'" [type]="'ghost'"
          ></lib-icon-button>
      </div>
      }
      }
    }
    <lib-icon-button [screen]="'mobile'" [icon]="'settings-sliders'" [style]="'rounded'" [type]="'ghost'"
      (click)="toggleSettingsDropdown()"
      lib-tooltip
      [yAxis]="'end'"
      [xAxis]="'end'"
      [tooltipContent]="'COMPONENTS.SHORTCUTS.CUSTOMIZE_SHORTCUTS'"></lib-icon-button>
  </div>
  <lib-dropdown-switch
    [dataSource]="listOptions"
    [isDisabled]="false"
    [show]="showSettingsDropdown()"
    [anchor]="mainAnchor"
    (showChange)="showSettingsDropdown.set($event)"
    xAxis="start"
    [yAxis]="enabledOptions.length > 5 ? 'center-end' : 'center-start'"
    (switchChange)="onSelectionChange($event)"
  >
  </lib-dropdown-switch>
}
